<template>
  <div :id="this.$route.name">
    <card>
      <template v-slot:header>
        <h4 class="d-inline">تنـظیـمـات کاربری</h4>
        <hr />
      </template>
      <template v-slot:content>
        <tab :tab="Tablist">
          <template v-slot:content0>
            <form @submit.prevent="">
              <div class="row">
                <div class="col-md-3 col-12">
                  <small class="text-dark">کلمه عبور فعلی : </small>
                  <input type="password" v-model="NowPass" id="NowPass" class="form-control text-center required" />
                </div>
                <div class="col-md-3 col-12">
                  <small class="text-dark">کلمه عبور جدید : </small>
                  <input type="password" @keyup="$PassProgress($route.name)" v-model="NewPass" id="NewPass" class="form-control text-center required required-Pass" />
                  <div class="row mt-2">
                    <div class="col-12">
                      <div class="progress-bar d-block" style="height: 5px">
                        <div style="width: 0%" id="progress-progress">
                          <b></b>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-12">
                  <small class="text-dark">تکرار کلمه عبور جدید: </small>
                  <input type="password" v-model="ConfirmPass" id="ConfirmPass" class="form-control text-center required" />
                </div>
                <div class="col-md-3 col-12 mt-4">
                  <!-- <b-button size="sm"  variant="success" @click="Savedata()">ثـبت کلمه عبور</b-button> -->
                  <button id="SeveData" type="submit" class="btn btn-success mr-1 w-100" dir="ltr" @click="Savedata">ثـبت کلمه عبور</button>
                </div>

                  
                
                <div class="col-md-4 col-12">
                  <small id="lblPhoneNumber">شماره موبایل</small>
                  <input type="text" v-model="DataAxiosDashboard.userMobile" id="PhoneNumber" class="form-control text-center" />
                </div>
                <div class="col-md-4 col-12">
                  <small id="LblDashboardTask">ورود دومرحله ای</small>
                  <span class="form-control px-2 text-center">
                    <div class="custom-control custom-switch" v-if="render">
                      <input type="checkbox" class="custom-control-input InputText" id="DashboardTask" @change="ChangeTaskDashboard($event, true)" v-model="DataAxiosDashboard.twoStepVerif" />
                      <label class="custom-control-label Pointer" for="DashboardTask">ورود دومرحله ای</label>
                    </div>
                  </span>
                </div>
                <div class="col-md-4 col-12">
                  <button @click="ChangeTaskDashboard($event, false)" class="w-100 btn btn-success mt-4">ثبت اطلاعات ورود دو مرحله ای  </button>
                </div>
                <!-- <div class="col-md-3 pt-4 col-12"></div> -->

               
              </div>
              <hr />
              <!-- <button class="btn btn-primary px-3 col-md-3 col-12" v-if="$session.get('UserInfo').tblUserId!=1" @click="OnCopyGridColumnAsRahbar">به روز رسانی ستون های جداول</button> -->
            </form>
          </template>
          <template v-slot:content1>
            <div class="row" v-if="!$session.get('CustomerInfo') & render">
              <div class="col-md-4 col-12">
                <div class="mt-2 text-center">
                  <small id="LblDashboardTask" class="d-none">نمایش کـارهـا هنگام ورود</small>
                  <span class="form-control p-1">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input InputText " id="DashboardTask" @change="ChangeTaskDashboard($event, false)" v-model="DataAxiosDashboard.DashboardTask" />
                      <label class="custom-control-label Pointer" for="DashboardTask">نمایش کـارهـا هنگام ورود</label>
                    </div>
                  </span>
                </div>
              </div>
              <div class="col-md-4 col-12">
                <button style="font-size: small" class="btn mt-2 btn-info px-3 w-100" v-if="$session.get('UserInfo').tblUserId != 1" @click="OnCopyGridColumnAsRahbar">به روز رسانی ستون های جداول</button>
                <button class="btn mt-2 btn-warning px-3 w-100" v-if="$session.get('UserInfo').tblUserId == 1" @click="synonymUpdate()">به روز رسانی Synonym ها</button>
              </div>
            </div>
          </template>
        </tab>
      </template>
    </card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import Tab from '@/components/Tab/Tab.vue'
export default {
  components: { Card, Tab },
  data() {
    return {
      render: true,
      tabs: [],
      tabCounter: 0,
      Tablist: [{ header: 'تنظیمات امنیتی' }, { header: 'تنظیمات پیشخوان' }],
      NowPass: '',
      NewPass: '',
      ConfirmPass: '',
      DataAxios_PutChangeUserPass: {
        ArryfildValue: null,
        Method: 'Put',
        Action: 'TarifKarbaran/b_updateTanzimatUser',
        Token: this.$session.get('Token'),
      },
      DataAxiosDashboard: { DashboardTask: this.$session.get('UserInfo').dashboardTask, tblUserId: this.$session.get('UserInfo').tblUserId, twoStepVerif: this.$session.get('UserInfo').twoStepVerif, userMobile: this.$session.get('UserInfo').userMobile },
      render: true,
    }
  },
  methods: {
    synonymUpdate() {
      var DataaxiosDepUser = {
        Action: 'TarifKarbaran/UpdateSynonym',
        Method: 'post',
        ArryfildValue: null,
      }
      this.$PostData(DataaxiosDepUser)
        .then((data) => {
          if (data.status === true) {
            this.$mySweetDefaultTost(false, 'synonym ها با موفقیت به روز شد', 'success', 3000)
          }
        })
        .catch((error) => {
          this.$mySweetDefaultTost(false, 'خطایی رخ داد', 'error', 3000)
          console.error('CATCH', error)
        })
    },
    Savedata() {
      if (this.$ValidForm(this.$route.name)) {
        if (this.NowPass == this.$session.get('UserInfoPss')) {
          if (this.NewPass != null || (this.NewPass != '' && this.ConfirmPass != null) || (this.ConfirmPass != '' && this.NowPass != null) || this.NowPass != '') {
            if (this.NewPass == this.ConfirmPass) {
              var DataChangePass = {}
              DataChangePass['tbluser'] = {}
              DataChangePass['OldPass'] = this.$session.get('UserInfo').pss
              DataChangePass.tbluser.Pss = this.ConfirmPass
              DataChangePass.tbluser.Id = this.$session.get('UserInfo').tblUserId
              DataChangePass.tbluser.UserName = this.$session.get('UserInfo').userName
              this.DataAxios_PutChangeUserPass.ArryfildValue = DataChangePass
              this.$PostData(this.DataAxios_PutChangeUserPass).then((data) => {
                if (data.status == 'Ok') {
                  this.$mySweetDefaultTost(false, 'عملیات تغییر کلمه عبور با موفقیت انجام شد لطفا مجددا وارد شوید', 'success', 6000)
                  this.$router.push('/')
                  this.$session.clear()
                } else {
                  this.$mySweetDefault('عملیات ناموفق', data.msg, 'error', 3000)
                }
              })
            } else {
              this.$mySweetDefaultTost(false, 'رمز جدید و تکرارش باهم مطابقت  ندارند.', 'error', 3000)
            }
          }
        } else {
          this.$mySweetDefaultTost(false, 'رمز ورود فعلی نادرست می باشد', 'error', 3000)
        }
      }
    },
    OnCopyGridColumnAsRahbar() {
      let DataAxios_Copycolumn = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'TarifKarbaran/b_CopySettingGrid',
        Token: this.$session.get('Token'),
      }
      DataAxios_Copycolumn.ArryfildValue.tblFromUserId = this.$session.get('UserInfo').tblUserId
      this.$PostData(DataAxios_Copycolumn)
        .then((data) => {
          if (data[0].ColDeleted == 'RowDeleted') {
            this.$toasted.success('چیدمان ستون های کاربری شما به روز شد', {
              action: {
                onClick: (e, toastObject) => {
                  toastObject.goAway(10000)
                },
              },
              duration: 2500,
            })
          } else {
            this.$mySweetDefaultTost('عملیات ناموفق', 'چیدمان ستون باخطا مواجه شد', 'warning', 2000)
          }
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    ChangeTaskDashboard(e, isTwoStepCombo) {
      if (isTwoStepCombo) {
        if (this.DataAxiosDashboard.userMobile == null || this.DataAxiosDashboard.userMobile.length != 11) {
          this.$mySweetDefaultTost('هشدار', 'شماره همراه شما ثبت نشده یا فرمت صحیحی ندارد امکان فعال کردن ورود دو مرحله ای وجود ندارد!', 'warning', 2000)
          this.DataAxiosDashboard.twoStepVerif = false
          this.render = false
          this.$nextTick(() => {
            this.render = true
          })
          return
        }
      } else {
        if (this.DataAxiosDashboard.userMobile.length < 11) {
          this.$toasted.error('شماره موبایل به درستی ثبت نگردیده', { duration: 3000 })
        } else {
          let DataAxios_Set = {
            ArryfildValue: {},
            Method: 'post',
            Action: 'TarifKarbaran/ChangeStatusTask',
            Token: this.$session.get('Token'),
          }
          DataAxios_Set.ArryfildValue = this.DataAxiosDashboard
          this.$PostData(DataAxios_Set)
            .then((data) => {
              if (data.status == 'Ok') {
                this.$toasted.success('وضعیت با موفقیت تغییر کرد ، برای اعمال تغیرات پیشنهاد می شود یک بار از سامانه خارج ودوباره وارد شوید', { duration: 4000 })
              } else {
                this.$toasted.error('خطایی در پیداکردن کاربر به وجود آمده، لطفا از سامانه خارج و دوباره وارد شوید', { duration: 3000 })
              }
            })
            .finally(() => {
              this.$store.state.renderComponentGrid = false
              this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true
              })

              this.render = false
              this.$nextTick(() => {
                this.render = true
              })
            })
        }
      }
    },
  },
}
</script>
<style scoped>
.progress-bar {
  overflow: hidden;
  height: 20px;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}

.progress-bar > div {
  /* background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent); */
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 25%, transparent 75%);
  background-size: 50px 50px;
  float: left;
  width: 0%;
  height: 100%;
  font-size: 12px;
  line-height: 20px;
  color: #ffffff;
  text-align: center;
  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  -webkit-transition: width 3s ease;
  -moz-transition: width 3s ease;
  -o-transition: width 3s ease;
  transition: width 3s ease;
  animation: progress-bar-stripes 2s linear infinite;
  /* background-color: #000000; */
}
</style>
